module.exports = __webpack_public_path__ + "static/viaggiare-442bed80f68ef5239ba32835cf1a1a18.jpg";